import { render, staticRenderFns } from "./MobilePhone.vue?vue&type=template&id=7f077e99&"
import script from "./MobilePhone.vue?vue&type=script&lang=js&"
export * from "./MobilePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports